import I18n from 'I18n';
import { CloseButton as _CloseButton } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
const CloseButton = _CloseButton;
const CUICloseButton = args => {
  return /*#__PURE__*/_jsx(CloseButton, Object.assign({
    "aria-label": I18n.text('connect.buttons.closeButton.ariaLabel')
  }, args));
};
export default CUICloseButton;